export default "__VITE_ASSET__XL6CsiNL__"